<script setup>
const props = defineProps({
  title: {
    type: String,
    required: true
  },
  center: {
    type: Object,
    required: true
  },
  type: { type: String, default: null }
})
const toggleItems = [
  {
    text: '5分毎',
    key: '5min'
  },
  {
    text: '1時間毎',
    key: '1hour'
  },
  {
    text: '今日明日',
    key: 'today-tomorrow'
  },
  {
    text: '2週間天気',
    key: 'week'
  }
]
const selectedTab = ref(toggleItems[1].key)
const isShowGolfLegend = ref(false)
const [fcst5mData, fcst1hData, fcst3dData, fcst2wData] = await Promise.all([
  useFetch('/api/wxdata/fcst5m', { query: { lat: props.center.lat, lon: props.center.lon } }),
  useFetch('/api/wxdata/fcst1h', { query: { lat: props.center.lat, lon: props.center.lon } }),
  useFetch('/api/wxdata/fcst3d', { query: { lat: props.center.lat, lon: props.center.lon } }),
  useFetch('/api/wxdata/fcst2w', { query: { lat: props.center.lat, lon: props.center.lon } })
]).then((responses) => responses.map((res) => res.data))
</script>

<template>
  <section class="weatherforecast">
    <CommonPageTitle
      :title="`${title.replace(/[（/]旧.*$/, '')}の天気予報`"
    />
    <div
      class="card"
    >
      <TableMinuteGolf
        v-if="selectedTab === '5min'"
        :table="fcst5mData"
      />
      <TableHourGolf
        v-if="selectedTab === '1hour'"
        :table="fcst1hData"
      />
      <TableTodayGolf
        v-if="selectedTab === 'today-tomorrow'"
        :table="fcst3dData"
      />
      <TableWeekGolf
        v-if="selectedTab === 'week'"
        :table="fcst2wData"
      />
      <GolfToggle
        v-model:selected="selectedTab"
        :list="toggleItems"
      />
    </div>
    <p
      class="legend"
      @click="isShowGolfLegend = !isShowGolfLegend"
    >
      凡例
    </p>
    <GolfLegend
      v-if="isShowGolfLegend"
      v-model:is-show-golf-legend="isShowGolfLegend"
    />
  </section>
</template>

<style lang="scss" scoped>
.weatherforecast {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .card {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 5px;
    border: solid 1px #dfe4f0;
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / .25);
    .toggle {
      margin-top: auto;
    }
  }
  .legend {
    margin-left: auto;
    color: #3569c0;
    text-decoration: underline;
    line-height: 1em;
    padding-left: 20px;
    background-image: url('https://gvs.weathernews.jp/golf/image/common/icon_legend.svg');
    background-position: left center;
    background-size: 15px;
    background-repeat: no-repeat;
    cursor: pointer;
  }
  @media (any-hover: hover) {
    .legend {
      transition: opacity .2s ease-in-out;
      &:hover {
        opacity: .6;
      }
    }
  }
}
</style>
